// extracted by mini-css-extract-plugin
export default {"title":"MobileMenu_title__jQOri","text":"MobileMenu_text__OQIk+","contactButton":"MobileMenu_contactButton__OO-Ya"};